import { EventMetadata } from '~analytics/EventMetadata';
import { EventTypes, PaywallScreens } from '~analytics/types';

const paywallScreenValues = Object.values(PaywallScreens);

export const paywallTouchEventMetadata: EventMetadata = {
  name: EventTypes.PaywallTouch,
  description:
    'A teacher interacted with a paywall prompt (feature gate, upsell modal, or banner).',
  category: 'Paywall',
  platform: 'client',
  status: 'active',
  properties: {
    feature_name: {
      type: 'enum',
      values: paywallScreenValues,
      description:
        'Identifier of the gated feature or screen that triggered the paywall.',
      required: true,
    },
    secondary_feature: {
      type: 'enum',
      values: paywallScreenValues,
      description:
        'Optional secondary feature identifier when the paywall is shared between two contexts.',
      required: false,
    },
  },
};
